export default "__VITE_ASSET__C3e_tStZ__"